module.exports = __webpack_public_path__ + "static/media/mio_allenatore_preferito1.30fab2af.jpg";